import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PreloginService } from './services/prelogin.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private preLoginService: PreloginService) { }

  canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.preLoginService.isUserLoggedIn() && this.isAuthenticated(activatedRoute.data.expectedRole)) {
      // TODO - Need to clarify this
      // CASE 1 - If from application, while navigating user reaches to 'Page Not Found' and press back then
      // sidebar wil not be visible, so to make it visible we set the flag to true (done below).
      // Ex - in sidebar create menu 'demo' with routerLink="/demo" and do nothing (not add it in app.routing).
      // Now, click it and go back --> side and top nav will not be visible.....

      // CASE 2 - BUT if user manually types some invalid url and lands to 'Page Not Found', then on pressing back
      // the sidebar will be visible, without setting the lag to true.
      this.preLoginService.setLoggedInFlagForNav(true);

      return true;
    }
    else {
      this.router.navigate(['/login']);
      return false;
    }
  }


  // For role based access
  public isAuthenticated(roles) {
    return roles.some(role => role === this.preLoginService.getCurrentRole());
  }

}
